import { FrequencyType } from '@ndvr/portfolio-api';

export const frequencyTypeToLabel = (frequencyType: FrequencyType) => {
    switch (frequencyType) {
        case FrequencyType.ONE_TIME:
            return 'One Time';
        case FrequencyType.DAILY:
            return 'Daily';
        case FrequencyType.WEEKLY:
            return 'Weekly';
        case FrequencyType.BI_WEEKLY:
            return 'Bi-Weekly';
        case FrequencyType.MONTHLY:
            return 'Monthly';
        case FrequencyType.QUARTERLY:
            return 'Quarterly';
        case FrequencyType.SEMI_ANNUALLY:
            return 'Semi-Annually';
        case FrequencyType.ANNUALLY:
            return 'Annually';
        default:
            return 'Unknown';
    }
};
